const admin = {
  updateAdmin: {
    name: '',
    avatar: null
  }
}

export default admin;